import CheckIcon from '@heroicons/react/outline/CheckIcon'
import startCase from 'lodash/startCase'

import { PlanName, PlanRenewalType } from '@tribeplatform/gql-client/types'
import { Card } from '@tribeplatform/react-ui-kit/Card'

import { PlanCardButton } from './PlanCardButton'
import {
  planDescription,
  planFeatures,
  planPrice,
  planPriceDetails,
} from './utils'

export const UpgradePlanCard = ({
  planName,
  renewalType,
  fullHeight = true,
  showButton = true,
}: {
  planName: PlanName
  renewalType: PlanRenewalType
  fullHeight?: boolean
  showButton?: boolean
}) => {
  return (
    <Card className={fullHeight ? 'h-full' : ''}>
      <Card.Header title={startCase(planName)} />
      <Card.Content>
        <div className="flex flex-col space-y-5 h-full">
          <div className="text-2xl">{planPrice(planName, renewalType)}</div>
          <div className="text-basicSurface-400">
            {planPriceDetails(planName, renewalType)}
          </div>
          <div className="text-basicSurface-900">
            {planDescription(planName)}
          </div>
          <div className="flex-grow flex flex-col space-y-5 text-basicSurface-900">
            {planFeatures(planName).map(feature => (
              <div key={feature} className="flex space-x-2">
                <CheckIcon className="h-6" /> {feature}
              </div>
            ))}
          </div>
          {showButton && (
            <div>
              <PlanCardButton planName={planName} renewalType={renewalType} />
            </div>
          )}
        </div>
      </Card.Content>
    </Card>
  )
}
